export const TOOL_NAMES = ['point', 'line', 'rect', 'polygon', 'cuboid', 'relation'] as const;

export const DEFAULT_LABEL_TEXT = 'noneLabel';

export const DEFAULT_LABEL_VALUE = 'noneAttribute';

export const DEFAULT_LABEL_COLOR = '#999';

export const DEFAULT_BACKGROUND_COLOR = '#F0F0F0';

export const VALID_RELATION_TOOLS = ['rect', 'polygon'] as const;
